import { Navigate, useParams } from 'react-router-dom';
import { projectTeamTarget } from '../ProjectPage/project-nav-targets';

/**
 * `/project/space/:teamId` 의 깃발 꺼짐 갈래 (2026-10-13).
 *
 * 홈 카드 · 새 스페이스 · 좌측 메뉴가 이 주소로 오게 바뀌었다(projectSpaceTarget).
 * 깃발이 꺼진 빌드에서 ProjectV2Route 의 기본 갈래(프로젝트 홈)로 떨어지면 «누른 스페이스가
 * 안 열린다» ⇒ 종전 목적지(스페이스 관리 화면, 그 스페이스 선택)로 넘긴다.
 * 깃발은 여기서 읽지 않는다 — 문이 이 부품을 fallback 으로 고른다.
 */
export function SpaceV2Fallback() {
  const { teamId } = useParams<{ teamId: string }>();
  return <Navigate to={teamId ? projectTeamTarget(teamId) : '/project/teams'} replace />;
}
